import { Device } from "@twilio/voice-sdk";

let currentTwilioAudioDevice: Device | null = null;

export const getTwilioAudioDevice = () => currentTwilioAudioDevice;

export const setTwilioAudioDevice = (device: Device | null) => {
  currentTwilioAudioDevice = device;
};

export const clearTwilioAudioDevice = (device?: Device | null) => {
  if (!device || currentTwilioAudioDevice === device) {
    currentTwilioAudioDevice = null;
  }
};

